const state = {
    adminRoom: {
        room: null,
        roomName: "",
        firstSection: null,
        secondSection: null,
        thirdSection: null,
    },
    isLoading: false
}

const getters = {
    adminRoom: state => state.adminRoom,
    isLoading: state => state.isLoading
}

const actions = {
    setLoading({ commit }, loading) {
        commit('saveLoading', loading);
    },

    setSections({ commit }, sectionsData) {
        commit('saveSections', sectionsData);
    },

    setAdminRoom({ commit }, roomData) {
        commit('saveAdminRoom', roomData);
    },
    clearAdminRoom({ commit }) {
        console.log("Clearing Admin Room");
        commit('clearAdminRoom');
    }
}

const mutations = {
    saveLoading(state, loading) {
        state.isLoading = loading;
    },
    saveSections(state, sectionsData) {
        state.adminRoom.firstSection = sectionsData.firstSection;
        state.adminRoom.secondSection = sectionsData.secondSection;
        state.adminRoom.thirdSection = sectionsData.thirdSection;
    },
    saveAdminRoom(state, roomData) {
        state.adminRoom = roomData;
    },
    clearAdminRoom(state) {
        state.adminRoom.room = null;
        state.roomName = null;
        state.firstSection = null;
        state.secondSection = null;
        state.thirdSection = null;
        state.adminRoom = {
            room: null,
            roomName: "",
            firstSection: null,
            secondSection: null,
            thirdSection: null,
        };
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}